import Select                from '@widesk-ui/components/form/Select';
import { TEXT_FONTS }        from '@tokamap/core';
import { textFontCssFamily } from '@tokamap/core';
import type { TextFont }     from '@tokamap/core';

const DEFAULT_FONT = '';

const CATEGORIES: { category: TextFont['category']; label: string; }[] = [
	{ category: 'sans', label: 'Sans empattement' },
	{ category: 'condensed', label: 'Étroites' },
	{ category: 'serif', label: 'Avec empattement' },
];

const FONT_OPTIONS = CATEGORIES.map(({ category, label }) => ({
	label,
	options: TEXT_FONTS.filter(font => font.category === category).map(font => ({ value: font.id, label: font.label })),
}));

const OPTIONS_WITH_DEFAULT = [{ value: DEFAULT_FONT, label: 'Noto Sans (par défaut)' }, ...FONT_OPTIONS];

export default function TextFontSelect({ value, mixed, withDefault = true, onChange }: {
	value: string | undefined;
	mixed?: boolean;
	withDefault?: boolean;
	onChange: (font: string | undefined) => void;
}) {
	return (
		<Select
			value={mixed ? undefined : (value ?? DEFAULT_FONT)}
			placeholder={mixed ? 'Mixte' : undefined}
			options={withDefault ? OPTIONS_WITH_DEFAULT : FONT_OPTIONS}
			optionRender={({ label, value: font }) => (
				<span style={{ fontFamily: typeof font === 'string' && font ? textFontCssFamily(font) ?? undefined : undefined }}>
					{label}
				</span>
			)}
			onChange={font => onChange(typeof font === 'string' && font ? font : undefined)}
		/>
	);
}
